import { Component, HostListener, Input } from "@angular/core";
import { Router } from "@angular/router";
import { Organization } from "../../../../entity/Organization";

@Component({
	selector: "organization-card-view",
	templateUrl: "./organization-card.component.html",
	styleUrls: ["./organization-card.component.scss"],
})
export class OrganizationCardComponent {

	@Input()
	public organization: Organization;

	private readonly router: Router;

	private constructor(router: Router) {
		this.router = router;
	}

	@HostListener("click")
	public async onClick(): Promise<void> {
		await this.router.navigate([`/organization/${this.organization.id}`]);
	}

}



// WEBPACK FOOTER //
// ./Frontend/src/app/components/organizations/organization-card.component/organization-card.component.ts